import React, { useEffect, useState } from 'react';
import API_SERVICE from 'shared/services/api-service';
import { notification, Carousel, Typography, Row, Col, Card, Input, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { SearchOutlined } from '@ant-design/icons';
import Parameters from 'shared/parameters';
import { useHistory } from 'react-router-dom';
import { AuthConsumer } from 'shared/contexts/AuthContext';
import applyIcon from '../../img/apply-icon.png';

const { Title, Text } = Typography;
export default function HomeBanner() {
    const { t } = useTranslation();
    const history = useHistory();
    const [banners, setBanners] = useState([]);
    const [search, setSearch] = useState('');

    useEffect(() => {
        API_SERVICE.fetchBanners().then((banners) => {
            setBanners(banners.data.data.items);
            // console.log('banners',banners)
        }).catch((e) => {
            notification.error({
                message: API_SERVICE.handleErrors(e),
            });
        });
    }, []);
    return (
        // <div className={'banner-wrapper'}>
        <div className={''}>
            <Carousel autoplay>
                {
                    banners.map(({ media, title, description }: any, index: number) => {
                        return <div key={index} className={'banner-inside-wrapper'}>
                            <div className='container-fluid bg-white pr-0'>
                                <div className='row d-flex flex-wrap align-items-center'>
                                    <div className='col-lg-4 col-md-4 col-sm-5'>
                                        <Title level={1} style={{'marginTop': '2rem'}}>{title}</Title>
                                        <p style={{fontSize:'17px'}}>
                                            <div dangerouslySetInnerHTML={{ __html: description }}/>
                                        </p>
                                        <AuthConsumer>
                                            {({ user }) => (
                                                !user ? <Button className='mr-md-4 mt-3 mt-md-0 btn btn-blue text-uppercase' onClick={() => {
                                                    history.push(`/register`)}
                                                }>
                                                Apply now
                                                <span>
                                                    <img src={applyIcon} className="ml-2" style={{width:"14px"}} />
                                                </span>
                                            </Button> : <></>
                                            )}
                                        </AuthConsumer>
                                        <div className="search-form">
                                            <div className='search-box'>
                                                <div className="input-group mb-3 bg-white br-5px" style={{border: '2px solid #4f46e5c4'}}>
                                                    <input type={'text'} className={'form-control'} placeholder={t('genDict.Find_Your_Course')}
                                                    onChange={(e: any) => {
                                                        setSearch(e.target.value);
                                                    }}
                                                    style={{height: '45px',border:'0px'}}/>
                                                    <div className="input-group-append">
                                                        <button className="btn btn-golden btn-header text-111827" type="submit"
                                                        onClick={() => {
                                                            history.push(`/courses?search=${search}`);
                                                        }}
                                                        style={{margin:'5px'}}>{t('genDict.Go')}</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-lg-8 col-md-8 col-sm-7'>
                                        <img src={Parameters.ImageBaseUrl + media.slug + media.ext} className={'img-fluid w-100'} />
                                    </div>
                                </div>
                            </div>
                            {/* <div className={'background-image'}
                                 style={{ backgroundImage: `url(${Parameters.ImageBaseUrl + media.slug + media.ext})` }}>
                                <Row style={{ width: '100vw' }}>
                                    <Col>
                                        <div className="search-form-wrapper">
                                            <div className="search-form">
                                                
                                                <Title level={4}>
                                                    <div dangerouslySetInnerHTML={{ __html: description }}/>
                                                </Title>
                                                <Button className='mr-md-4 mt-3 mt-md-0 btn btn-blue text-uppercase btn-header'>
                                                    Apply now
                                                </Button>
                                                <Input
                                                    className={'search-box'}
                                                    size={'large'}
                                                    onPressEnter={() => {
                                                        history.push(`/courses?search=${search}`);
                                                    }}
                                                    onChange={(e: any) => {
                                                        setSearch(e.target.value);
                                                    }}
                                                    placeholder={t('genDict.search')}
                                                    suffix={<div className='search-icon-wrapper'><SearchOutlined/></div>}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div> */}
                        </div>;
                    })
                }
            </Carousel>
        </div>
    );
}
